module.exports = __webpack_public_path__ + "fonts/a8ts/TT8.woff2";